import { Typography } from '@mui/material';
import i18n from '../../i18n';

/**
 * 渲染「较昨日」环比趋势文案（增加/减少/持平及数量）。
 * @param numValue - 今日相对昨日的变化量
 */
const RenderTrend = ({ numValue }: { numValue: number }) => {
    /** 增加态配置 */
    const increaseConfig = {
        directionKey: 'intelligent_risk_control_page_ai_analysis_trend_direction_increase',
        color: 'funcSp1',
    };
    /** 减少态配置 */
    const decreaseConfig = {
        directionKey: 'intelligent_risk_control_page_ai_analysis_trend_direction_decrease',
        color: 'success',
    };
    /** 持平态配置 */
    const stableConfig = {
        directionKey: 'intelligent_risk_control_page_ai_analysis_trend_direction_stable',
        color: '',
    };

    /** 当前趋势配置 */
    let status;
    if (numValue > 0) {
        status = increaseConfig;
    } else if (numValue < 0) {
        status = decreaseConfig;
    } else {
        status = stableConfig;
    }

    /** 是否为持平（无数量变化） */
    const isStable = status === stableConfig;

    return (
        <Typography variant="body2">
            {i18n.t('intelligent_risk_control_page_ai_analysis_trend_vs_yesterday_prefix')}
            {i18n.t(status.directionKey)}
            <span className={status.color} style={{ marginLeft: '4px' }}>
                {isStable
                    ? i18n.t('intelligent_risk_control_page_ai_analysis_trend_no_change')
                    : i18n.t('intelligent_risk_control_page_ai_analysis_trend_count', { count: Math.abs(numValue) })}
            </span>
        </Typography>
    );
};

export default RenderTrend;
